// Single source of truth for the "User Content Warning" feature copy.
// Matching backend constants live in `backend/utils/userContentWarning.js`.
import { getTextFromLanguageCodeAndKey } from "../pages/trivia/languages";

// English copy lives in languages.js under "en" -- no separate constant here.
export const getUserContentWarningText = (trivvyLanguage) =>
  getTextFromLanguageCodeAndKey(trivvyLanguage, "userContentWarning");

// Admin-facing, not translated (same as the rest of the admin panel).
export const USER_CONTENT_WARNING_TOOLTIP =
  "When turned on, automatically warn users about sharing controlled / confidential information or inappropriate language in their Trivvy responses.";
